module.exports = __webpack_public_path__ + "img/empty.1e5c1047.png";